import './style.scss';
import $ from 'jquery';
import gsap from 'gsap';

function buttonFunction() {
	if(!$(".wp-block-thefuturblocks-circle-button").length) {
		return;
	}
	$(".wp-block-thefuturblocks-circle-button").each(function() {
		var self = $(this),
			wrapper = self.find('.wp-block-thefuturblocks-circle-button__wrapper'),
			link = self.find('.wp-block-thefuturblocks-circle-button__link'),
			before = self.find('.wp-block-thefuturblocks-circle-button__link-before'),
		    text = self.find('.wp-block-thefuturblocks-circle-button__text'),
		    dataHoverTextColor = link.attr("data-tcolor"),
		    dataHoverBorderColor = link.attr("data-bcolor"),
		    tl = gsap.timeline({paused:true});

		tl.fromTo(before, {scale:0}, {duration: 0.3, scale:1})
		.to(link, {duration: 0.3, borderColor: dataHoverBorderColor}, "<")
		.to(text, {duration: 0.3, color: dataHoverTextColor}, "<")
		if(link.hasClass("has-t-anim")) {
			tl.to(text, {duration: 0.3, color: dataHoverTextColor,skewY:-5,yPercent:-100,ease: "sine.in"}, "<")
			.fromTo(text, {yPercent:100,skewY:5}, {duration:0.3,skewY:0,yPercent:0,immediateRender:false,ease:"sine.out"})
		}

		link.on("mouseenter", () => {
			tl.play();
		}).on("mouseleave", () => {
			tl.reverse();
		})
		
		wrapper.on("mousemove", callMoveIn);
		wrapper.on("mouseleave", callMoveOut);

		function callMoveIn(e){
		  moveIn(e, link, 50);
		}

		function callMoveOut(){
		  moveOut(link);
		}

		function moveIn(e, target, movement){
		  var boundingRect = wrapper[0].getBoundingClientRect();
		  var relX = e.clientX - boundingRect.left;
		  var relY = e.clientY - boundingRect.top;

		  gsap.to(target, {
		    duration: 0.3,
		    x: (relX - boundingRect.width/2) / boundingRect.width * movement,
		    y: (relY - boundingRect.height/2) / boundingRect.width * movement,
		    ease: "sine.out",
		    overwrite: "auto"
		  });
		}

		function moveOut(target){
		  gsap.to(target, {
		    duration: 0.3,
		    x: 0,
		    y: 0,
		    overwrite: "auto"
		  });
		}
	})
}
buttonFunction();